import { render, staticRenderFns } from "./Tarifications.vue?vue&type=template&id=313e0d1e&"
import script from "./Tarifications.vue?vue&type=script&lang=js&"
export * from "./Tarifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports